import { NBSP } from '../../../constants/symbols';

export const SIDEBAR_BACK_TEXT = 'На страницу услуги';
export const SIDEBAR_BACK_LOCATION = '/legal-check';
export const SIDEBAR_TITLE = 'Проверка недвижимости';
export const SIDEBAR_MESSAGE = `Укажите адрес объекта и загрузите несколько документов. Юристы проверят недвижимость и продавца, выявят риски при${NBSP}покупке и подготовят рекомендации, как обезопасить себя${NBSP}при${NBSP}заключении сделки`;
